import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyIssueRoute: InvariantJiraRoute = {
	name: 'legacy-issue',
	path: '/browse/:issueKey(\\w+-\\d+)(.*)',
	query: ['jql!=(.+)', 'filter!=(.+)'],
};
